import { Action } from '@ngrx/store';
import { ContactPersonRole } from '@ordersnproducts/modules/order-builder/modules/location-specification/models/order-management/contact-person-role.model';

export enum ActionTypes {
  INIT = '[Contact Person] Init',
  SET_NAME = '[Contact Person] Set Name',
  SET_COUNTRY_AREA_CODE = '[Contact Person] Set Country Area Code',
  SET_PHONE = '[Contact Person] Set Phone',
  SET_EXTENSION = '[Contact Person] Set Extension',
  SET_EMAIL = '[Contact Person] Set Email',
  ADD_CONTACT = '[Contact Person] Add Contact',
  ADD_CONTACT_FAILURE = '[Contact Person] Add Contact Failure',
  CLEAR = '[Contact Person] Clear',
  FETCH_ROLES = '[Contact Person] Fetch Roles',
  STORE_ROLES = '[Contact Person] Store Roles',
  CLEAR_ROLES = '[Contact Person] Clear Roles',
  SET_ROLE = '[Contact Person] Set Role',
}

export class Init implements Action {
  readonly type: string = ActionTypes.INIT;
  constructor(public payload?: any) {}
}

export class SetName implements Action {
  readonly type: string = ActionTypes.SET_NAME;
  constructor(public payload: string) {}
}

export class SetRole implements Action {
  readonly type: string = ActionTypes.SET_ROLE;
  constructor(public payload: number) {}
}

export class SetCountryAreaCode implements Action {
  readonly type: string = ActionTypes.SET_COUNTRY_AREA_CODE;
  constructor(public payload: string) {}
}

export class SetPhone implements Action {
  readonly type: string = ActionTypes.SET_PHONE;
  constructor(public payload: string) {}
}

export class SetExtension implements Action {
  readonly type: string = ActionTypes.SET_EXTENSION;
  constructor(public payload: string) {}
}

export class SetEmail implements Action {
  readonly type: string = ActionTypes.SET_EMAIL;
  constructor(public payload: string) {}
}

export class AddContact implements Action {
  readonly type: string = ActionTypes.ADD_CONTACT;
  constructor(public payload?: any) {}
}

export class AddContactFailure implements Action {
  readonly type: string = ActionTypes.ADD_CONTACT_FAILURE;
  constructor(public payload?: any) {}
}

export class Clear implements Action {
  readonly type: string = ActionTypes.CLEAR;
  constructor(public payload?: any) {}
}

export class FetchRoles implements Action {
  readonly type: string = ActionTypes.FETCH_ROLES;
  constructor(public payload?: any) {}
}

export class StoreRoles implements Action {
  readonly type: string = ActionTypes.STORE_ROLES;
  constructor(public payload: ContactPersonRole[]) {}
}

export type Actions =
  | Init
  | SetName
  | SetRole
  | SetCountryAreaCode
  | SetPhone
  | SetExtension
  | SetEmail
  | AddContact
  | AddContactFailure
  | Clear
  | FetchRoles
  | StoreRoles;
